export function captureFocusedLetterBox(): {wordIndex: number, letterPosition: number} | null {
    // first, find out if a letterbox is the source of focus
    const focused = document.activeElement;
    if (!(focused instanceof HTMLElement)) {
        return null;
    }

    // get data about letterbox currently in focus
    const wordIndex: number = Number(focused.dataset.wordIndex);
    const letterPosition: number = Number(focused.dataset.letterPosition);

    // check that data is well formed
    // will be NaN if the data didn't exist (not on the element or no element in focus)
    if (
        Number.isNaN(wordIndex)
        || Number.isNaN(letterPosition)
    ) {
        return null;
    }

    // okay to return values
    return { wordIndex, letterPosition};
}